<template>
  <div class="chart02" ref="chartdiv"></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4maps from "@amcharts/amcharts4/maps";
import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
import am4geodata_usaLow from "@amcharts/amcharts4-geodata/usaLow";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);
export default {
  name: "chart02",
  mounted() {
    let chart = am4core.create(this.$refs.chartdiv, am4maps.MapChart);
    chart.logo.height = -15000;
    // Set map definition
    chart.geodata = am4geodata_worldLow;

    // Set projection
    chart.projection = new am4maps.projections.Miller();

    // Create map polygon series
    let polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());

    // Make map load polygon (like country names) data from GeoJSON
    polygonSeries.useGeodata = true;

    // Configure series
    let polygonTemplate = polygonSeries.mapPolygons.template;
    polygonTemplate.tooltipText = "{name}";
    polygonTemplate.fill = am4core.color("#DDD");

    // Create hover state and set alternative fill color
    let hs = polygonTemplate.states.create("hover");
    hs.properties.fill = am4core.color("#367B25");

    // Remove Antarctica
    polygonSeries.exclude = ["AQ"];
    polygonSeries.data = [
      {
        id: "TH",
        name: "Thailand",
        value: 100,
        fill: am4core.color("#91C949"),
      },
      {
        id: "UK",
        name: "United Kingdom",
        value: 100,
        fill: am4core.color("#9BCE5A"),
      },
      {
        id: "KH",
        name: "Cambodia",
        value: 100,
        fill: am4core.color("#A7D36D"),
      },
      {
        id: "VN",
        name: "Vietnam",
        value: 100,
        fill: am4core.color("#B1D97F"),
      },
      {
        id: "DE",
        name: "Germany",
        value: 100,
        fill: am4core.color("#BDDE91"),
      },
      {
        id: "FR",
        name: "France",
        value: 100,
        fill: am4core.color("#C8E4A3"),
      },
      {
        id: "PH",
        name: "Philippines",
        value: 100,
        fill: am4core.color("#D3E9B6"),
      },
      {
        id: "MY",
        name: "Malaysia",
        value: 100,
        fill: am4core.color("#D8ECBF"),
      },
      {
        id: "IN",
        name: "India",
        value: 100,
        fill: am4core.color("#E9F4DA"),
      },
      {
        id: "US",
        name: "USA",
        value: 100,
        fill: am4core.color("#F4FAEC"),
      },
    ];
    polygonTemplate.propertyFields.fill = "fill";
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
};
</script>

<style lang="scss">
.chart02 {
  width: 100%;
  height: 300px;
}
</style>